import { HttpHeaders } from "@angular/common/http";

export const environment = {
    production: true,
    apiURL: '',
    jsonOptions: { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) },
    withCredentials: false
};
